// Import all portrait images so Vite includes them in the build
// This gives us the correct asset URLs after Vite processes them

const portraits = {
  maya: {
    neutral: new URL('../../public/assets/portraits/maya/neutral.png', import.meta.url).href,
    happy: new URL('../../public/assets/portraits/maya/happy.png', import.meta.url).href,
    surprised: new URL('../../public/assets/portraits/maya/surprised.png', import.meta.url).href,
  },
  james: {
    neutral: new URL('../../public/assets/portraits/james/neutral.png', import.meta.url).href,
    happy: new URL('../../public/assets/portraits/james/happy.png', import.meta.url).href,
    surprised: new URL('../../public/assets/portraits/james/surprised.png', import.meta.url).href,
  },
  alex: {
    neutral: new URL('../../public/assets/portraits/alex/neutral.png', import.meta.url).href,
    happy: new URL('../../public/assets/portraits/alex/happy.png', import.meta.url).href,
    surprised: new URL('../../public/assets/portraits/alex/surprised.png', import.meta.url).href,
  },
  sam: {
    neutral: new URL('../../public/assets/portraits/sam/neutral.png', import.meta.url).href,
    happy: new URL('../../public/assets/portraits/sam/happy.png', import.meta.url).href,
    surprised: new URL('../../public/assets/portraits/sam/surprised.png', import.meta.url).href,
  },
  jordan: {
    neutral: new URL('../../public/assets/portraits/jordan/neutral.png', import.meta.url).href,
    happy: new URL('../../public/assets/portraits/jordan/happy.png', import.meta.url).href,
    surprised: new URL('../../public/assets/portraits/jordan/surprised.png', import.meta.url).href,
  },
};

export default portraits;
